import ReactGA from 'react-ga4';

import authenticatedRequest from '../helpers/authenticatedRequest';
import { API } from '../../common';

const cancelPaymentIntent = async ({ paymentIntentID }) => {
  ReactGA.event({
    category: 'Stripe',
    action: 'Cancel payment intent',
  });

  try {
    const response = await authenticatedRequest(
      'post',
      `${API.stripe.cancelPaymentIntent}`,
      {
        paymentIntentID,
      }
    );
    return { payment_intent_status: response?.data?.status };
  } catch (error) {
    console.error('Error during Payment intent cancel', {
      error,
    });
    return {
      error,
      payment_intent_status:
        error?.response?.data?.error?.payment_intent?.status,
    };
  }
};

export default cancelPaymentIntent;
